<section class="xl:container xl:m-auto xl:pl-[15px] xl:pr-[15px]" id="aboutauthor">
    <div class="p-6 md:px-[70px] md:py-12 bgbanner bg-cover bg-center bg-[#F5F1F1]">
        <h3 class="text-32 text-black font-libre-regular mb-6">
            About the Author
        </h3>
        <div class="flex mb-6">
            <div>
                <h4 class="text-18 text-black mb-[6px]">Anirban Mallick</h4>
                <p class="text-14 text-[#666666] mb-0">
                    Senior Executive Director & Business Head, Client Relations
                    (South & East)
                </p>
            </div>
        </div>
        <p class="text-14 md:text-16 text-black mb-0">
            Anirban Mallick brings over 23 years of experience in managing HNI
            portfolios across global banks such as ABN AMRO, RBS, DBS, and Kotak
            Mahindra Bank. An alumnus of ICFAI Business School, he is known for
            his strong leadership and relationship-building expertise. Beyond
            finance, he is deeply engaged in philanthropy and sport.
        </p>
    </div>
</section>